import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';
import logo from '../../assets/logo.png';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <nav className="navbar">
      {/* Left: Logo */}
      <div className="navbar-left">
        <NavLink to="/" className="navbar-logo">
          <img src={logo} alt="ProdPilot Logo" className="logo-image" />
          <h1 className="logo-text">ProdPilot</h1>
        </NavLink>
      </div>

      {/* Center: Nav Links */}
      <div className="navbar-center">
        <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          <li>
            <NavLink exact to="/" className="nav-link" activeClassName="active">Home</NavLink>
          </li>
          <li>
            <NavLink to="/timer" className="nav-link" activeClassName="active">Timer</NavLink>
          </li>
          <li>
            <NavLink to="/splitter" className="nav-link" activeClassName="active">Splitter</NavLink>
          </li>
          <li>
            <NavLink to="/pulse" className="nav-link" activeClassName="active">Pulse</NavLink>
          </li>
          <li>
            <NavLink to="/habits" className="nav-link" activeClassName="active">Habits</NavLink>
          </li>
          <li>
            <NavLink to="/contact" className="nav-link" activeClassName="active">Contact</NavLink>
          </li>
        </ul>
      </div>

      {/* Right: Buy Me a Coffee + Hamburger */}
      <div className="navbar-right">
        {/* Desktop */}
        <a
          href="https://buymeacoffee.com/prodpilot"
          target="_blank"
          rel="noopener noreferrer"
          className="buy-coffee-btn desktop-visible"
        >
          ☕ Buy Me a Coffee
        </a>

        {/* Mobile */}
        <a
          href="https://buymeacoffee.com/prodpilot"
          target="_blank"
          rel="noopener noreferrer"
          className="buy-coffee-btn mobile-visible"
        >
          ☕ Buy Me a Coffee
        </a>

        <div
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
